export default __webpack_public_path__ + "static/media/attention-icon.121b8d68.svg";